import {Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";

const TABLE_HEAD = ["#", "کاربر", "مباشر", "نوع سرویس", "گرایش", "قیمت", "هزینه", "کد تخفیف", "درصذ", "ایجاد"];

export function DiscountSiteCostGrid({
                                       discountSiteCostReport,
                                     }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مباشر": "agent_name",
    "نوع سرویس": "product_type",
    "گرایش": "branch_name",
    "قیمت": "price",
    "هزینه": "site_share",
    "کد تخفیف": "discount_code",
    "درصذ": "discount_percentage",
    "ایجاد": "created_at"
  }

  const headSortable = {
    "#": false,
    "معرف": true,
    "کاربر": true,
    "مباشر": true,
    "نوع سرویس": true,
    "گرایش": true,
    "قیمت": true,
    "هزینه": true,
    "کد تخفیف": true,
    "درصذ": true,
    "ایجاد": true
  }

  return (
    <div className="w-full">
      <table className="mt-4 w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="w-full textCenter">
        {discountSiteCostReport.map(
          ({
             id,
             product_type,
             branch_name,
             person_name,
             person_phone,
             agent_name,
             agent_phone,
             price,
             site_share,
             discount_code,
             discount_percentage,
             created_at,
           }, index) => {
            const isLast = index === discountSiteCostReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {product_type === 'reservation' ? "خدمات" : "مشاوره"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(price, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(site_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {discount_code}
                    </Typography>
                  </div>
                </td>


                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(discount_percentage)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    {created_at?.length > 0 &&
                      <>
                        <Typography color="blue-gray">
                          {persianNumberFormat(created_at.split(" ")[0])}
                        </Typography>
                        <Typography color="blue-gray">
                          {persianNumberFormat(created_at.split(" ")[1])}
                        </Typography>
                      </>
                    }
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}